<template>
    <div class="wrapper">
        <header>
            <!-- <TheHeaderBar :title="'通知详情'"/> -->
            <!-- <van-nav-bar
                left-text="通知详情"
                left-arrow
                @click-left="onClickLeft"
            /> -->
        <div class="header">
            <BaseHeader :title="'详情'"/>
        </div>
        </header>
        <div class="content nows mycontent">
            <h3 style="text-align: center;margin-bottom: -30px;">{{  data.title }}</h3>
            <div v-html="data.content"></div>
        </div>
    </div>
</template>
    
<script>
	import {
		getWxSharService
	} from '../service/weChatService';
    import BaseHeader from "../components/BaseHeader";
    import { getNowsServive } from "@/service/untilService.js";
	//import {wecharShare} from "../util/weChat.js";
    export default {
        name: "Nows",
        data(){
            return{
                id:0,
                data:{},
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            console.log(this.id)
            this.getNows();
			this.share();
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{
            onClickLeft(){
                this.$router.go(-1);
            },
            getNows(){
                getNowsServive(this.id).then(res => {
                    if(res.status === 1){
                        this.data = res.datas;
                    }else{
                        console.log(res.msg)
                    }
                })
            },
			share() {
				const that = this;
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					if (result.status === 1) {
						console.log('share', result);
						that.$wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: result.datas.appId, // 公众号名称，由商户传入
							timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
							nonceStr: result.datas.nonceStr, // 随机串
							signature: result.datas.signature, // 微信签名
							jsApiList: ['updateTimelineShareData',
								'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
						});
						that.$wx.ready(function() {
							//分享到朋友圈
							that.$wx.updateTimelineShareData({
								title: that.data.title, // 分享标题
								link: 'https://www.shoudaole.cn/dist/#/nows/' + that.id,
								imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
								success: function() {
									// Toast('分享成功');
								}
							});
							//分享给朋友
							that.$wx.updateAppMessageShareData({
								title: that.data.title, // 分享标题
								desc: '收到乐分享', //分享描述
								link: 'https://www.shoudaole.cn/dist/#/nows/' + that.id,
								imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
								success: function() {
									// Toast('分享成功');
								}
							});
						});
					} else {
						Toast(result.msg);
					}
				});
			},
        },
        components: {
            BaseHeader,
        }
    }
</script>

<style scoped lang="scss">
.wrapper{
    background-color: #ffffff!important;
    padding: 0 10px;
    header{
        // padding-bottom: 46px;
    }
    h3{
        // text-align: center;
    }
}
   
</style>
<style >
	.mycontent{
		background-color: #FFFFFF !important;
		margin-top:10px;
		font-size: 14px;
		line-height: 20px ;
	}
    .nows img{
       width: 100%;
    }
</style>